module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_fooldal4.35dad28c.jpg";